import { LoginType } from '@Modules/auth/types';
import { OperationType } from '@Modules/core/types/OperationType';
import { LoginAdapter } from '@Modules/auth/adapters';
import { ILoginDto } from '@Modules/auth/dto/ILogin.dto';
import axios from 'axios';
import EnvConfig from '@Config/env.config';
import { CardHoldersAdapter } from '../adapters/CardHoldersAdapter';
import { ICardHolderType } from '../types/ICardHolderType';

const ROOT_URL = EnvConfig.API_URL;

export async function login(data: ILoginDto): Promise<LoginType> {
  axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
  // const { data: response } = await axios.post(`${ROOT_URL}/login`, data);
  const response = await axios.get(`${ROOT_URL}/login-success`);
  return LoginAdapter.adapt(response.data);
}

export function register(): OperationType {
  // get request with Axios
  return {
    success: true,
    message: 'Your regislation is performed successfuly',
  };
}

export async function getAccountRouting(payload: ICardHolderType) {
  console.log('Payload: ', payload);
  const response = await axios.get(`${ROOT_URL}/cardholders`);
  return CardHoldersAdapter.adapt(response.data);
}

export async function updateAccountRouting(payload: ICardHolderType) {
  console.log('Payload: ', payload);
  const response = await axios.get(`${ROOT_URL}/cardholders`);
  return CardHoldersAdapter.adapt(response.data);
}

export async function getCommissionSettings(payload: ICardHolderType) {
  console.log('Payload: ', payload);
  const response = await axios.get(`${ROOT_URL}/cardholders`);
  return CardHoldersAdapter.adapt(response.data);
}

export async function updateCommissionSettings(payload: ICardHolderType) {
  console.log('Payload: ', payload);
  const response = await axios.get(`${ROOT_URL}/cardholders`);
  return CardHoldersAdapter.adapt(response.data);
}


// Backend <-> Dto [ <-> dto -> adpter -> model -> pages/components ]
